document.addEventListener("DOMContentLoaded", function () {
  const drawerMenuParent = document.querySelector(".drawer-menu--second-style");
  const linkSize = drawerMenuParent.dataset.linkSize;
  const swiperContainer = drawerMenuParent.querySelector(
    ".drawer-menu__parents-wrapper"
  );
  const swiperWrapper = swiperContainer.querySelector(
    ".drawer-menu__primary-links"
  );
  if (linkSize > 5) {
    swiperContainer.classList.add("swiper");
    swiperWrapper.classList.add("swiper-wrapper");
  }
  const swiperSlides = swiperWrapper.querySelectorAll(".parent-link");
  if (linkSize > 5) {
    swiperSlides.forEach((slide) => {
      slide.classList.add("swiper-slide");
    });
  }

  const slidesArray = Array.from(swiperSlides);

  const activeSlide = slidesArray.findIndex((slide) =>
    slide.classList.contains("parent-link--has-children")
  );

  const createSwiper = () => {
    if (swiperContainer && window.innerWidth < 960 && linkSize > 5) {
      const swiper = new Swiper(swiperContainer, {
        slidesPerView: "auto",
        initialSlide: activeSlide,
      });
    }
  };

  createSwiper();
  window.addEventListener("resize", createSwiper);
  const slidesWithChildren = document.querySelectorAll(
    ".parent-link--has-children"
  );
  slidesWithChildren.forEach((slide, index) => {
    index = index + 1;
    slide.addEventListener("click", () => {
      const childrenWrapper = document.querySelector(
        `.drawer-menu__children-wrapper[data-meganav-menu-index="${index}"]`
      );
      const childrenWrappers = document.querySelectorAll(
        ".drawer-menu__children-wrapper"
      );
      childrenWrappers.forEach((wrapper) => {
        wrapper.classList.remove("visible-children-wrapper");
      });
      slidesWithChildren.forEach((slide) => {
        slide.classList.remove("parent-link--has-children-active");
      });
      if (childrenWrapper) {
        childrenWrapper.classList.add("visible-children-wrapper");
        slide.classList.add("parent-link--has-children-active");
      }
    });

    if (index === activeSlide) {
      slide.classList.add("parent-link--has-children-active");
    }
  });

  const childrenWrappers = document.querySelectorAll(
    ".drawer-menu__children-wrapper"
  );

  childrenWrappers.forEach((wrapper) => {
    if (+wrapper.dataset.meganavMenuIndex === activeSlide) {
      wrapper.classList.add("visible-children-wrapper");
    }
  });
});
